import React from 'react'

import Layout from '../components/Layout'
import SEO from '../components/Seo'
import HeaderTitle from '../components/HeaderTitle'
import Form from '../components/Form'

const Contact = ({ data: { prismicContact } }) => (

    <Layout theme='dark'>

        <SEO title={prismicContact.data.header_title.text} />
        
        <HeaderTitle label={prismicContact.data.header_title.text}/>

        <Form />

    </Layout>

)

export default Contact

export const pageQuery = graphql`
    query ContactQuery {
        prismicContact {
            data {
                header_title {
                    text
                }
            }
        }
    }
`